import getTrackingParams from './getTrackingParams';

export const WHATSAPP_FALLBACK_URL = `https://wa.me/447344282544?text=${encodeURIComponent(
  'Hi, do I have a case?',
)}`;
const TIMEOUT_MS = 800;

// Opens WhatsApp from the header button. The tab is opened synchronously inside the click,
// otherwise Safari and mobile browsers block a window.open that follows an await.
// If /api/whatsapp-click fails or is slow, the tab gets the plain link, as before.
const openWhatsApp = async () => {
  const win = window.open('', '_blank');
  if (win) win.opener = null;

  const go = (url) => {
    if (win && !win.closed) {
      win.location.href = url;
    } else {
      window.location.href = url;
    }
  };

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);

  try {
    const res = await fetch('/api/whatsapp-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        tracking: getTrackingParams() || {},
        page_url: window.location.href,
        referrer: document.referrer,
      }),
      signal: controller.signal,
    });
    const data = res.ok ? await res.json() : null;
    go(data && data.wa_url ? data.wa_url : WHATSAPP_FALLBACK_URL);
  } catch (e) {
    go(WHATSAPP_FALLBACK_URL);
  } finally {
    clearTimeout(timer);
  }
};

export default openWhatsApp;
